import React from 'react'
import {
  Button,
  Row,
  Col,
  Container,
  PageHeaderLight,
  PageContainer,
  CenteredSpinner,
  SummaryService
  // Badge,
  // Card
} from '../../../index'
import { useQuery } from 'react-query'
import { Link, useHistory, useParams } from 'react-router-dom'
import InfoCard from './components/InfoCard/InfoCard'
import { SectionTitle, ListItem } from './style'
import { UnableToLoad } from './components/UnableToLoad'
import { SummaryLabelValue } from './components/SummaryLabelValue'
// import ReportingPreview from './reportingPreview.svg'

export const EmployerPortalSummary: React.FC<{
  isBrokerPortal?: boolean
  summaryService: SummaryService
}> = ({ isBrokerPortal, summaryService }) => {
  const history = useHistory()
  const { groupId } = useParams<{ groupId: string }>()

  const employeesUrl = isBrokerPortal
    ? `/groups/${groupId}/employees`
    : '/employees'

  const queryKey = isBrokerPortal ? ['summary'] : ['summary', groupId]
  const {
    data: summaryData,
    isLoading,
    isError
  } = useQuery(
    queryKey,
    () => summaryService.getSummary(isBrokerPortal ? groupId : ''),
    {
      refetchOnWindowFocus: false,
      retry: 1
    }
  )

  const labels: Record<string, any> = {
    companyName: 'Company Name',
    groupID: 'Group ID',
    coverageStart: 'Coverage start date',
    coverageEnd: 'Coverage end date',
    brokers: 'Brokers on account',
    generalAgency: 'General Agency on Account',
    newHireWaitingPeriod: 'Waiting Period for New Hires'
  }

  if (isError) {
    return (
      <Container className="d-flex flex-column justify-content-center h-100">
        <UnableToLoad />
      </Container>
    )
  }

  return (
    <>
      {isLoading ? (
        <CenteredSpinner />
      ) : (
        <>
          <PageHeaderLight
            style={{ marginBottom: '2.8rem', alignItems: 'flex-start' }}
          >
            <PageContainer size="lg">
              <h1>Welcome back!</h1>
            </PageContainer>
          </PageHeaderLight>
          <PageContainer size="lg">
            {/* {!isBrokerPortal && (
              <Card
                className="pl-3 mb-5"
                style={{
                  width: '80%'
                }}
              >
                <Card.Body>
                  <Row noGutters>
                    <Col>
                      <Row>
                        <div className="d-flex align-items-center">
                          <Badge
                            style={{
                              backgroundColor: '#0099AE',
                              color: 'white'
                            }}
                          >
                            NEW
                          </Badge>
                          <span
                            style={{
                              fontWeight: 600,
                              fontSize: 20,
                              marginLeft: 10,
                              color: '#343A40'
                            }}
                          >
                            Reporting now available!
                          </span>
                        </div>
                      </Row>
                      <Row>
                        <span
                          style={{
                            color: '#6C757D',
                            fontWeight: 500,
                            fontSize: 18
                          }}
                        >
                          Now you can see group reports online with the
                          Reporting option.
                        </span>
                      </Row>
                      <Row>
                        <Button
                          className="mt-3"
                          onClick={() => history.push('/reporting')}
                        >
                          Try it now!
                        </Button>
                      </Row>
                    </Col>
                    <Col xs="auto">
                      <img src={ReportingPreview} alt="" height="100%" />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )} */}
            <Row>
              <Col>
                {summaryData?.inRenewal === true &&
                  summaryData?.onboardingStatus !== 'completed' &&
                  summaryData?.onboardingStatus !== 'under_review' &&
                  !isBrokerPortal && (
                    <>
                      <SectionTitle>Updates</SectionTitle>
                      <InfoCard
                        title="Your Business Onboarding Is Open"
                        subtitle={
                          <p>
                            Your renewal business onboarding is ready for you.
                            Select your plans for the upcoming plan year!
                          </p>
                        }
                        footer={
                          <Button
                            onClick={() => history.push('/business/onboarding')}
                          >
                            Start onboarding
                          </Button>
                        }
                        className="mb-5"
                      />
                    </>
                  )}

                <Row style={{ marginBottom: '2.5rem' }}>
                  <Col md={6} xs={12}>
                    <Link to={employeesUrl}>
                      <InfoCard
                        title="Total Premium Members"
                        subtitle={<h2>{summaryData?.employeeCount}</h2>}
                        footer={<small className="text-muted">Members</small>}
                        className="my-3 my-md-0"
                      />
                    </Link>
                  </Col>
                </Row>
                <Row style={{ marginBottom: '1.25rem' }}>
                  <Col>
                    <SectionTitle style={{ marginBottom: '1rem' }}>
                      Account information
                    </SectionTitle>
                    {Object.keys(labels).map((key: string) => {
                      if (
                        ['brokers', 'generalAgency'].includes(key) &&
                        !(summaryData as any)[key]
                      ) {
                        return null
                      }
                      return (
                        <ListItem key={key}>
                          <p className="text-muted">{labels[key]}</p>
                          <p>
                            <SummaryLabelValue
                              summary={summaryData}
                              label={key}
                            />
                          </p>
                        </ListItem>
                      )
                    })}
                  </Col>
                </Row>
              </Col>
            </Row>
          </PageContainer>
        </>
      )}
    </>
  )
}
